













import { Vue, Component, Prop } from 'vue-property-decorator';
import FieldSettingsContainer from '../FieldSettingsContainer.vue';
import Button from '@/components/Button.vue';
import { EButtonTypes } from '@/enums/ButtonType.ts';

@Component({
  components: {
    Button,
    FieldSettingsContainer,
  },
})
export default class FieldDelete extends Vue {
  @Prop() selectedFieldsCount: number;
  @Prop() height: string;

  EButtonTypes = EButtonTypes;

  get title(): string {
    if (this.selectedFieldsCount > 1) {
      return `${this.$t('delete')} ${this.selectedFieldsCount} ${this.$t('fields')}`;
    }

    return this.$t('delete').toString();
  }

  get subHeader(): string {
    if (this.selectedFieldsCount > 1) {
      return this.$t('do-you-want-to-delete-these-fields').toString();
    }

    return this.$t('do-you-want-to-delete-this-field').toString();
  }

  handleDelete() {
    this.$emit('delete');
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleDelete();
    }
  }

  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}
